import { useMutation, useQuery } from "@tanstack/react-query";
import { REGISTRATION_QUERY_KEY } from "./registration.constants";

import { getSecurityQuestions, registerUser } from "../../services/registrationApi";

export const useSecurityQuestionsQuery = () =>
  useQuery({
    queryKey: REGISTRATION_QUERY_KEY,
    queryFn: getSecurityQuestions,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
    placeholderData: [],
    retry: false,
    select: (items) =>
      items
        .map((item) => ({
          value: String(item.quesId ?? ""),
          label: String(item.question ?? "").trim(),
        }))
        .filter((item) => item.value && item.label),
  });

export const useRegisterMutation = () =>
  useMutation({
    mutationFn: (payload) => registerUser(payload),
  });